import { render, staticRenderFns } from "./AyadiCheckbox.vue?vue&type=template&id=6edcacf3&scoped=true"
import script from "./AyadiCheckbox.vue?vue&type=script&lang=js"
export * from "./AyadiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AyadiCheckbox.vue?vue&type=style&index=0&id=6edcacf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edcacf3",
  null
  
)

export default component.exports